/**
 * Flatten nested object int single level to be used with form post to back-end PHP
 *
 * @param name Name of object
 * @param nested Nested object
 *
 * @example
 *  const token = {
 *    id: 'tok_1Hm9mc2d6kOsParVgZIFb6Hw',
 *    object: 'token',
 *    card: {
 *      id: 'card_1Hm9mc2d6kOsParVCZ4OfTHc',
 *      object: 'card',
 *      address_city: null,
 *      address_country: null,
 *      address_line1: null,
 *      address_line1_check: null,
 *      address_line2: null,
 *      address_state: null,
 *      address_zip: '90066',
 *      address_zip_check: 'pass',
 *      brand: 'Visa',
 *      country: 'US',
 *      customer: null,
 *      cvc_check: 'pass',
 *      dynamic_last4: null,
 *      exp_month: 10,
 *      exp_year: 2023,
 *      fingerprint: 'yLuYEhQGin86YWCS',
 *      funding: 'credit',
 *      last4: '1111',
 *      name: 'lksjdf@lksdjf.com',
 *      tokenization_method: null,
 *      type: 'Visa',
 *    },
 *    client_ip: '107.184.145.46',
 *    created: 1605064446,
 *    email: 'lksjdf@lksdjf.com',
 *    livemode: false,
 *    type: 'card',
 *    used: false,
 *  };
 *
 *  const flattenToken = flatten('token', token);
 */
export function flatten(nested: any, name: string = ''): any {
  const arrayOfNested = [
    {
      label: name,
      obj: nested,
    },
  ];
  const flattenObject: { [key: string]: any } = {};
  while (arrayOfNested.length) {
    const { label, obj } = arrayOfNested.pop() || {};

    for (const key in obj) {
      if (
        typeof obj[key] === 'object' &&
        obj[key] !== null &&
        obj[key] !== undefined &&
        Object.keys(obj[key]).length
      ) {
        arrayOfNested.push({
          label: label ? `${label}[${key}]` : key,
          obj: obj[key],
        });
      } else {
        flattenObject[label ? `${label}[${key}]` : key] = obj[key];
      }
    }
  }

  return flattenObject;
}
